import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MetaService } from '@app/core/services/meta.service';
import { SocialLinksComponent } from '@app/layout/social-links/social-links.component';

@Component({
  selector: 'app-contacts-page',
  templateUrl: './contacts.page.html',
  styleUrls: ['./contacts.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SocialLinksComponent],
})
export class ContactsPage implements OnInit {
  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    const metadata = {
      title: 'ImageBase.pro – Get in Touch with Us',
      description:
        'Have questions or need support? Contact ImageBase.pro for inquiries about stock images, partnerships, or assistance with our platform.',
      keywords:
        'contact ImageBase.pro, support, customer service, stock images inquiry, partnership, help, get in touch',
    };

    this.metaService.setMetadata(metadata);
  }
}
